import { useContext } from 'react';
import { PlatformContext, type PlatformContextValue } from '../provider/PlatformContext';

/**
 * Read the active `PlatformContextValue` (`platform` tag, `apiBaseUrl`,
 * identity provider). Throws if used outside `PlatformProvider` so a
 * misconfigured provider tree fails loudly at the first consumer instead of
 * surfacing as a confusing `undefined` later.
 */
export const usePlatform = (): PlatformContextValue => {
  const ctx = useContext(PlatformContext);
  if (!ctx) {
    throw new Error('usePlatform must be used inside <PlatformProvider>');
  }
  return ctx;
};
